"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video3DMasterSchema = void 0;
exports.Video3DMasterSchema = {
    "$id": "https://www.redbull.com/schemas/master/video-3d.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Video3DMaster",
    "description": "Video content produced in 3D for capable devices like VR/AR headsets.",
    "type": "object",
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "type": {
            "enum": [
                "rrn:master:video-3d"
            ],
            "type": "string"
        },
        "relationships": {
            "type": "object",
            "properties": {
                "translations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:video-3d"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                },
                "translatedFrom": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "object",
                            "properties": {
                                "id": {
                                    "type": "string",
                                    "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                },
                                "type": {
                                    "enum": [
                                        "rrn:content:video-3d"
                                    ],
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "draftTranslations": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
                                    },
                                    "type": {
                                        "enum": [
                                            "rrn:content:video-3d"
                                        ],
                                        "type": "string"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "additionalProperties": false
        },
        "meta": {
            "type": "object",
            "properties": {
                "published": {
                    "type": "boolean"
                },
                "status": {
                    "type": "string"
                },
                "version": {
                    "type": "number"
                },
                "dateCreated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                },
                "dateUpdated": {
                    "type": "string",
                    "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z$"
                }
            }
        }
    },
    "required": [
        "id",
        "type",
        "relationships",
        "meta"
    ]
};
//# sourceMappingURL=data:application/json;base64,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